import { render, staticRenderFns } from "./PurchaseOrderNewDetail.vue?vue&type=template&id=3fd8fca7"
import script from "./PurchaseOrderNewDetail.vue?vue&type=script&lang=js"
export * from "./PurchaseOrderNewDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports